import { render, staticRenderFns } from "./weightManagementDetail.vue?vue&type=template&id=4d2c3920&scoped=true"
import script from "./weightManagementDetail.vue?vue&type=script&lang=js"
export * from "./weightManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./weightManagementDetail.vue?vue&type=style&index=0&id=4d2c3920&prod&lang=scss&scoped=true"
import style1 from "./weightManagementDetail.vue?vue&type=style&index=1&id=4d2c3920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c3920",
  null
  
)

export default component.exports